import React from "react";
import constants from "../../../../common/constants";
import ClaimAnalystLocationInput from "./ClaimAnalystLocationInput";
import Location from "../../../../models/Location";
import { Divider, Header } from "semantic-ui-react";
import InvestigatorLocationInput from "./InvestigatorLocationInput";

interface Props {
  value: UserLocationInputValue[][];
  onChange(value: UserLocationInputValue[][]): void;
  roleTitle: string | string[];
  locations: Location[];
}

const UserLocationInput = ({ roleTitle, ...rest }: Props) => {
  let content = null;
  let reporteeCondition = '';
  
  if (roleTitle === constants.roleTitle.investigator) {
    reporteeCondition = constants.roleTitle.investigator
  } else if (roleTitle.includes("State/District")) {
    reporteeCondition = "State/District";
  } else {
    reporteeCondition = '';
  }

  switch (reporteeCondition) {
    case constants.roleTitle.investigator:
      content = <InvestigatorLocationInput {...rest} />;
      break;
    case "State/District":
      content = <ClaimAnalystLocationInput {...rest} />;
      break;
    default:
      content = null;
      break;
  }

  if (content === null) {
    return null;
  } else {
    return (
      <>
        <Divider />
        <Header as="h4" color="grey">
          Work Location
        </Header>
        {content}
      </>
    );
  }
};

export interface UserLocationInputValue {
  state: string;
  district: string;
}

UserLocationInput.defaultProps = {
  value: [],
  onChange: () => {},
};

export default React.memo(UserLocationInput);
